;(function module() {
  angular.module('app.ui.form.ctrls').controller('DeletePositionController', [
    'positionId',
    '$uibModalInstance',
    'PositionApi',
    '$rootScope',
    function controller(
      positionId,
      $uibModalInstance,
      PositionApi,
      $rootScope
    ) {
      var vm = this
      vm.positionId = positionId

      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }

      vm.delete = async () => {
        $rootScope.isPositionDeleted = true
        const {status} = await PositionApi.deletePositionById(vm.positionId)
        if (status === 200) $uibModalInstance.close(true)
        else $uibModalInstance.close(false)
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/delete-position/delete-position.ctrl.js